import React, { RefObject } from 'react'
import Chart, { ChartTypeRegistry } from 'chart.js/auto'
import { ChartConfiguration } from 'chart.js/auto'
import 'chart.js/auto'
/**
 * Returns a chartjs ref and chart instance
 * @see src\components\tables\allocation-mobile-component\allocation-pie.tsx for a simple usage example
 * @param options
 * @param dependencies
 * @returns
 */
export const useChartJS = <D>(
  options: ChartConfiguration,
  dependencies: Array<D>,
): [RefObject<HTMLCanvasElement>, ChartTypeRegistry | null] => {
  const ref = React.useRef<HTMLCanvasElement>(null)
  const chartId = React.useRef<string | null>(null)
  let chart: Chart | null = null
  React.useEffect(() => {
    if (chartId?.current !== null) {
      return
    }
    if (ref && ref.current) {
      chart = new Chart(ref.current, options)
      chartId.current = chart.id
    }
  }, dependencies)
  return [ref, chart]
}
